/**
 * Page title utilities for hierarchical browser tab titles
 *
 * @changeHistory
 * - 2026-04-25: Added centralized page title formatting and route resolution (GitHub Copilot)
 * - 2026-07-07: Switched to shared route metadata for page-label resolution (Codex)
 */

import type { User } from '@shared/stores/auth.store';
import { getPageLabel } from './route-metadata';

const APP_NAME = 'AgentPortal';

type Role = User['role'];

const ROLE_AREA_LABELS: Record<Role, string> = {
  agent: 'Agent',
  broker: 'Broker',
  admin: 'Admin',
  transaction_coordinator: 'Transaction Coordinator',
};

const getAreaLabel = (isAuthenticated: boolean, role: Role | undefined): string => {
  if (!isAuthenticated || !role) {
    return 'Public';
  }

  return ROLE_AREA_LABELS[role] ?? 'User';
};

export const buildPageTitle = ({
  isAuthenticated,
  pathname,
  role,
}: {
  isAuthenticated: boolean;
  pathname: string;
  role?: Role;
}): string => {
  const areaLabel = getAreaLabel(isAuthenticated, role);
  const pageLabel = getPageLabel(pathname);

  return [APP_NAME, areaLabel, pageLabel].join(' - ');
};
